import React from 'react';
import { steps } from '../../data/steps';
export function TrainingSection() {
  return <section id="former" className="bg-white py-20 lg:py-28" data-id="element-72" data-mp="10ywk4m90ce05">
      <div className="mx-auto grid max-w-shell gap-14 px-5 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:px-8" data-id="element-73" data-mp="10x3enaa4rztq">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-74" data-mp="15wfzjphfywto">
          <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-75" data-mp="1aprb23x781rx">
            De la curiosité au brevet, en quatre étapes
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/65" data-id="element-76" data-mp="1kn5gl8hl365g">
            Aucune de ces étapes n’a de durée imposée. Le rythme est celui de votre disponibilité et de la
            météo.
          </p>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/b4273c72-e379-40d4-b1d5-97412c96b42a.jpg" alt="Un instructeur prépare un vol avec un élève pilote près d’un ULM sur une base en herbe" className="mt-8 h-64 w-full rounded-xl object-cover lg:h-72" data-id="element-77" data-mp="1todbdgkw5ous" />
        </div>

        <ol className="relative" data-id="element-78" data-mp="3asm1ukde5sb2">
          <span className="absolute left-[19px] top-3 bottom-3 w-px bg-line lg:left-[23px]" aria-hidden="true" data-id="element-79" data-mp="3atnf8vhvqqvy" />
          {steps.map((step, index) => <li key={step.id} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-80" data-mp="320k1sn78ie1b" data-mpi={index}>
              <span className="ffp-display relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-line bg-white text-[15px] font-bold text-navy lg:h-12 lg:w-12 lg:text-base" data-id="element-81" data-mp="2x0xoyevbizt1">
                {index + 1}
              </span>
              <div className="pt-1.5" data-id="element-82" data-mp="3pn8rhv2hjash">
                <h3 className="ffp-display text-xl font-bold text-ink lg:text-[22px]" data-id="element-83" data-mp="3kp79ldgsphil">{step.title}</h3>
                <p className="mt-2 max-w-xl text-[15px] leading-relaxed text-ink/65" data-id="element-84" data-mp="3frovl8nx8c3q">{step.description}</p>
                <p className="mt-3 inline-block rounded bg-cloud px-2.5 py-1 text-[13px] font-semibold text-navy" data-id="element-85" data-mp="29buychiphwme">
                  {step.detail}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}